import React from 'react';
import { v4 as uuidv4 } from 'uuid';

function Icon(props) {
  const id = `ls_icon_${uuidv4()}`;
  return (
    <svg
      fill="currentColor"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      viewBox="0 0 12 10"
      className="flex-shrink-0 tw-mr-2"
      {...props}
    >
      <path
        id={id}
        d="M12 3.5V8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 8V3.5h12ZM3.486 5.096c-.196 0-.196 0-.362.062-.166.062-.166.062-.29.17-.124.108-.124.108-.204.256-.06.111-.06.111-.086.238l-.014.086.468.072c.028-.208.028-.208.152-.346.124-.138.124-.138.328-.138.192 0 .192 0 .322.118s.13.118.13.318c0 .168 0 .168-.078.298-.058.097-.058.097-.147.194l-.063.064L2.55 7.56V8h1.884v-.44H3.158l.816-.78c.096-.088.096-.088.178-.182.082-.094.082-.094.144-.198.062-.104.062-.104.098-.222.036-.118.036-.118.036-.254 0-.204 0-.204-.078-.358s-.078-.154-.21-.26C4.01 5.2 4.01 5.2 3.84 5.148c-.17-.052-.17-.052-.354-.052Zm2.793.072h-.436l-.883.712.28.332.56-.46V8h.48V5.168Zm2.35.536H8.22v.88h-.88v.408h.88v.88h.409v-.88h.88v-.408h-.88v-.88ZM0 2A1.5 1.5 0 0 1 1.5.5h9A1.5 1.5 0 0 1 12 2H0Z"
      />
      <use xlinkHref={`#${id}`} fillRule="evenodd" />
    </svg>
  );
}

export default Icon;
